import React from 'react'
import Main from '../../cpn/Main'
import BalanceElseList from '../../finance/balance/BalanceElseList'
function ElsePaid() {
    return (
        <Main   t1='财务'  t2='其他收支' n2='/ElseIndex' t3='其他支出单'>
            <BalanceElseList
                main_type_id='5'
                main_type_name='其他支出单'
            />
        </Main>
    )
}

export default ElsePaid